import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// بعد index.css لا قبله: الترتيب يضمن علوّها على أصناف Tailwind حتى عند تساوي الدقّة
import './theme/dark.css';
import './theme/dark.generated.css';
import { App } from './App.tsx';
import { registerPwa } from './pwa.ts';
import { installBackButton } from './lib/nativeBack.ts';
import { installGuideLinks } from './guide/guideLink.ts';

registerPwa();
// إشعار «موضوع جديد في الدليل» على الموبايل يفتح الموضوع نفسه (04/10/2026) — قبل App حتى يقرأ العنوانَ مُحوَّلًا
installGuideLinks();
// زرّ «رجوع» في تطبيق أندرويد: للتاب السابق لا خروجٌ من التطبيق (03/10/2026)
void installBackButton();

// جزءٌ من البناء لم يعد على الخادم (صفحةٌ مفتوحة من نسخةٍ قديمة، وملفُّها ضاع): إعادةُ تحميلٍ واحدة تجلب
// النسخة الحالية بدل خطأٍ في وجه المستخدم (بندٌ من مراجعة 23/09/2026). النشرُ يُبقي الملفات القديمة
// (release.sh) فهذا نادر — ومرّةٌ كل دقيقة على الأكثر، فلا حلقةَ إعادة تحميل إن كان العطل في الخادم.
window.addEventListener('vite:preloadError', e => {
  try {
    const last = Number(sessionStorage.getItem('icontravel.chunkReload') ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('icontravel.chunkReload', String(Date.now()));
  } catch { return; }
  e.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
